import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
} from '@valuecase/ui-components'
import { VLoaderAnimationFullSizeCentered } from './VLoader/VLoader'

interface SpaceDeleteModalProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  spaceName: string
  isArchived: boolean
  onConfirm: () => Promise<void>
  onArchiveClick: () => Promise<void>
  isDeleting: boolean
}

const SpaceDeleteModal = ({
  isOpen,
  onOpenChange,
  spaceName,
  isArchived,
  onConfirm,
  onArchiveClick,
  isDeleting,
}: SpaceDeleteModalProps) => {
  const handleConfirm = async () => {
    await onConfirm()
  }

  const handleArchive = async () => {
    await onArchiveClick()
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className='min-w-[580px]'>
        <AlertDialogHeader iconName='trash-outline' iconClassName='text-warning-s4'>
          Delete space
        </AlertDialogHeader>
        <AlertDialogDescription>
          <p className='text-sm text-grey-s5 text-center'>
            You&apos;re about to delete the space <b className='font-extrabold'>{spaceName}</b>.
            This is non-reversible. Do you want to proceed?
          </p>
        </AlertDialogDescription>

        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction variant='danger' leadingIcon='trash-outline' onClick={handleConfirm}>
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>

        {!isArchived && (
          <p className='text-sm text-grey-s5 text-center mt-3'>
            Please rather{' '}
            <button
              onClick={handleArchive}
              className='text-primary-s5 no-underline font-extrabold hover:text-primary-s6 border-none m-0 p-0 min-w-0'
            >
              archive
            </button>{' '}
            my space.
          </p>
        )}

        {isDeleting && (
          <div
            className='absolute inset-0 bg-white flex items-center pb-11 rounded-b-lg'
            onClick={(event) => event.stopPropagation()}
          >
            <VLoaderAnimationFullSizeCentered />
          </div>
        )}
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default SpaceDeleteModal
